import { effect, inject, Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { LoginFormComponent } from '../components/molecules/login-form/login-form.component';
import { getState } from '@ngrx/signals';
import { ActiveUserStore } from '../stores/user/active-user.state';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {
  private loginDialogRef: DynamicDialogRef | null = null; // Keep track of open dialog
  readonly userStore = inject(ActiveUserStore);

  constructor(private dialogService: DialogService) {
    effect(() => {
      const userState = getState(this.userStore);
      if (userState.isLoggedIn) this.loginDialogRef?.close();
    });
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.includes('api/authentication/status')) {
      return next.handle(req); // Pass the request through without changes
    }

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        // Handle 401/403 Unauthorized error
        if (error.status === 401 || error.status === 403) {
          console.error('API request failed with 401/403: Unauthorized');

          // Open the login dialog if not already open
          if (!this.loginDialogRef) {
            this.loginDialogRef = this.dialogService.open(LoginFormComponent, {
              header: 'Ihr Login ist abgelaufen',
              width: '33rem',
              closable: false,
            });
          }
        }

        // Pass the error to the caller
        return throwError(() => error);
      })
    );
  }
}
